var React = require('react');

function BlobBgTop (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M492.288 96.0816C514.72 164.064 432.057 266.656 336.517 330.931C240.561 395.205 131.728 421.162 67.3426 377.076C2.95685 332.579 -16.9819 218.45 15.0032 137.283C46.9884 56.1161 130.898 7.91028 236.822 0.906015C342.332 -6.09825 469.857 27.687 492.288 96.0816Z","fill":"white"}));
}

BlobBgTop.defaultProps = {"width":"496","height":"399","viewBox":"0 0 496 399","fill":"none"};

module.exports = BlobBgTop;

BlobBgTop.default = BlobBgTop;
